















import {
  defineComponent,
} from '@vue/composition-api';
import _ from 'lodash';
import { useFormat } from '@ideavivat/vivat-2';

import useDownloadReport from '@/useDownloadReport';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useAuth from '@/useAuth';

const NOW = useFormat.date().computerShortDate();

const VehicleWork = defineComponent({
  // components: {},
  setup() {
    const { me } = useAuth();
    const { getCSVReport } = useDownloadReport();
    const { translateDistanceType, distanceTypeToChipClass } = useDeliveryAreaCode();

    return {
      me,

      getCSVReport,
      translateDistanceType,
      distanceTypeToChipClass,
    };
  },
});

export default VehicleWork;
